import React from 'react'
import { ViewStyle } from 'react-native'

import styled from 'styled-components/native'

import { ButtonSize } from '../../atoms/baseButton/BaseButton'
import { IconButton } from '../../atoms/iconButton/IconButton'
import { Tooltip } from '../../atoms/tooltip/Tooltip'

export type HoverActionItem = {
  id: string
  onPress: () => void
  icon: React.ReactNode
  label: string
  accessibilityLabel?: string
  testId?: string
}
export type HoverActionsProps = {
  items: HoverActionItem[]
  onFocus: () => void
  onHover: () => void
  onBlur: () => void
  testID?: string
  style?: ViewStyle
}

const Container = styled.View(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  width: 'fit-content',
  backgroundColor: theme.colors.backgroundPrimary,
  borderRadius: '20px',
  zIndex: 1,
  border: `1px solid ${theme.colors.borderDefault}`,
}))

const IconContainer = styled.View({
  height: '32px',
  width: '32px',
  justifyContent: 'center',
  alignItems: 'center',
})

export const HoverActions: React.FC<HoverActionsProps> = ({ items, onFocus, onHover, onBlur, testID, style }) => {
  return (
    <Container testID={testID} style={style} onMouseDown={(event) => event.preventDefault()}>
      {items.map((item) => (
        <Tooltip
          key={item.id}
          asChild
          closeOnScroll
          hoverEnabled
          content={item.label}
          placement='top'
          testID={item.testId}
        >
          <IconButton
            testID={item.testId}
            onPress={item.onPress}
            accessibilityLabel={item.accessibilityLabel ?? item.label}
            onFocus={onFocus}
            onHoverIn={onHover}
            onBlur={onBlur}
            leftIcon={<IconContainer>{item.icon}</IconContainer>}
            size={ButtonSize.SMALL}
          />
        </Tooltip>
      ))}
    </Container>
  )
}
